import { render, staticRenderFns } from "./PhoneDisplay.vue?vue&type=template&id=6c2525ee&scoped=true&"
import script from "./PhoneDisplay.vue?vue&type=script&lang=ts&"
export * from "./PhoneDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./PhoneDisplay.vue?vue&type=style&index=0&id=6c2525ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2525ee",
  null
  
)

export default component.exports